// Version-2 with seperate Select option for the form and inout fields-
import React, { useState, useEffect } from 'react';
import {
  Box,
  // Button,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  MenuItem,
} from '@material-ui/core';
import Spinner from '../../common/Spinner/Spinner';
import { Button } from "../../common/Button/Button"
import { toast } from "react-toastify";
import FormModalMarketConnect from './FormModalMarketConnect';

export default function PersonaDetailMarketConnectTab({ value, index, title, userMarketConnectPersonaDetails, handleSubmitPersonaDetails, isPersonaLoading, isPersonaFormOpen, setIsPersonaFormOpen, selectedResourceInstanceId, handleFormCancel, setIsFormOpen, isFormOpen, uniqueMarketOppInstanceId, handleUpdatePersonaDetail, marketConnectAlreadyFilledPersonaInstanceId, resourcesDetails, isTestimonialScreen }) {
  // const [isFormOpen, setIsFormOpen] = useState(false);
  const [formData, setFormData] = useState({
    "nResourceInstanceId": "",
    "Market Opportunity Type": '',
    "Market Opportunity Name": '',
    "Revenue from Opportunity": '',
    "Market channel cost": '',
    "Discount Amount (Paid by deAsra)": '',
    "Stall rent (paid by Entrepreneur)": '',
    "Gross profit": '',
    "Additional cost for the opportunity disclosed by Entrepreneur(SGA)": '',
    "Learnings": '',
    "Challenges": '',
  });

  const [isEdit, setIsEdit] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [marketConnectResourcesOfUser, setMarketConnectResourcesOfUser] = useState([])
  const [leftResourcesForAddingPersona, setLeftResourcesForAddingPersona] = useState([])
  const [allResourcePersonaDetails, setAllResourcePersonaDetails] = useState([]);

  const [oppTypeNameLabels, setOppTypeNameLabels] = useState({
    "MKTLINKAGESHOPINSHOP": "Shop in Shop",
    "MKTLINKAGEBULKBUYER": "Bulk Buyer",
    "MKTLINKAGECORPLINKAGE": "Corporate Linkage",
    "MKTLINKAGEEXHIBITION": "Exhibitions",
    "MKTLINKAGEEXPORT": 'Exports',
    "MKTLINKAGEECOM": 'E-Commerce',
    "DIGITALVISKIT": "Digital Visibility Kit"
  })

  // useEffect to get the oppType and title from resource detail for market conenct form
  useEffect(() => {
    if (resourcesDetails?.MarketOpportunities) {
      setMarketConnectResourcesOfUser(resourcesDetails.MarketOpportunities);

      let allMarketConnect = resourcesDetails?.MarketOpportunities;
      console.log(allMarketConnect, ">>>>>allMarketConnect")
      let fillingDefaultDataInPersonaDetails = allMarketConnect.map((resourceObj) => {
        // checking if persona details exist for the instanceId if exists spread it with resource details and if not set default empty keys
        let findPersonaForInstanceId = userMarketConnectPersonaDetails?.find((personaObj) => personaObj?.nResourceInstanceId == resourceObj?.nResourceInstanceId);
        if (findPersonaForInstanceId) {
          return {
            ...findPersonaForInstanceId,
            ...resourceObj,
            "Market Opportunity Type": resourceObj["sResourceDisplayName"] ? resourceObj["sResourceDisplayName"] : "N/A",
            "Market Opportunity Name": oppTypeNameLabels[resourceObj["sResourceID"]] ? oppTypeNameLabels[resourceObj["sResourceID"]] : "N/A",
            "isAlreadyPersonaExisting": true, // if persona already existitng then flag for all persona to show edit button
          }
        } else {
          return {
            "nResourceInstanceId": "",
            "Market Opportunity Type": resourceObj["sResourceDisplayName"] ? resourceObj["sResourceDisplayName"] : "N/A",
            "Market Opportunity Name": oppTypeNameLabels[resourceObj["sResourceID"]] ? oppTypeNameLabels[resourceObj["sResourceID"]] : "N/A",
            "Revenue from Opportunity": '',
            "Market channel cost": '',
            "Discount Amount (Paid by deAsra)": '',
            "Stall rent (paid by Entrepreneur)": '',
            "Gross profit": '',
            "Additional cost for the opportunity disclosed by Entrepreneur(SGA)": '',
            "Learnings": '',
            "Challenges": '',
            "isAlreadyPersonaExisting": false, // if persona not already existitng then flag for all persona to show add button
            ...resourceObj,
          }
        }
      })

      setAllResourcePersonaDetails([...fillingDefaultDataInPersonaDetails])

      console.log(userMarketConnectPersonaDetails, ">>>>userMarketConnectPersonaDetails in market connect useEffect")
      console.log(uniqueMarketOppInstanceId, ">>>>uniqueMarketOppInstanceId");

      const alreadyFilledPersonaResourceIds = userMarketConnectPersonaDetails?.map((obj) => {
        const { nResourceInstanceId } = obj;
        return nResourceInstanceId;
      })
      console.log(alreadyFilledPersonaResourceIds, ">>>alreadyFilledPersonaResourceIds market connect");

      if (alreadyFilledPersonaResourceIds) {
        const personaDetailResourceAddingLeft = uniqueMarketOppInstanceId?.filter((resourceId) => !alreadyFilledPersonaResourceIds.includes(resourceId))
        console.log(personaDetailResourceAddingLeft, ">>>>personaDetailResourceAddingLeft");
        setLeftResourcesForAddingPersona(personaDetailResourceAddingLeft);
      }
    } else {
      setMarketConnectResourcesOfUser([]);
    }
    // setLoading(false);
  }, [resourcesDetails, uniqueMarketOppInstanceId, userMarketConnectPersonaDetails]);

  if (value !== index) return null;

  const handleInputChange = (e) => {
    // const { name, value } = e.target;
    // setFormData({ ...formData, [name]: value });

    const { name, value } = e.target;

    if (name === "nResourceInstanceId") {
      const selectedResourceDetails = marketConnectResourcesOfUser.find((obj) => {
        return obj.nResourceInstanceId == value
      })
      console.log(selectedResourceDetails, ">>>>selectedResourceDetails");

      const { sResourceDisplayName, sResourceID } = selectedResourceDetails;

      setFormData({ ...formData, [name]: value, "Market Opportunity Type": oppTypeNameLabels[sResourceID] ? oppTypeNameLabels[sResourceID] : "", "Market Opportunity Name": sResourceDisplayName ? sResourceDisplayName : "" });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleFormToggle = () => {
    setIsFormOpen(!isFormOpen);
  };

  const handleAddEditButton = (rowData, action) => {
    if (action === "edit") {
      console.log(rowData, ">>>>rowData on handleEdit exprt consult");
      setIsFormOpen(true);
      setFormData(rowData);
      setIsEdit(true);
      setIsModalOpen(true)
    } else if (action === "add") {
      console.log(rowData, ">>>>rowData on handleEdit exprt consult");
      setIsFormOpen(true);
      setFormData(rowData);
      setIsEdit(false);
      setIsModalOpen(true)
    }

  }

  const handleUpdateButtonClick = (formData) => {
    console.log(formData, ">>>>update form data  market connect");

    if (!formData["nResourceInstanceId"]) {
      toast(String("Resource-ID is required"), {
        autoClose: 5000,
        type: toast.TYPE.ERROR,
      });
      setIsModalOpen(false)
    } else {
      const {
        nResourceInstanceId,
        "Market Opportunity Type": marketOppType,
        "Market Opportunity Name": marketOppName,
        "Revenue from Opportunity": revenueFromOpp,
        "Market channel cost": marketChannelCost,
        "Discount Amount (Paid by deAsra)": discountAmount,
        "Stall rent paid by Entrepreneur": stallRent,
        "Gross profit": grossProfit,
        "Additional cost for the opportunity disclosed by Entrepreneur(SGA)": addCostForOppDisclosed,
        Learnings,
        Challenges,
        ...remFormData
      } = formData

      handleUpdatePersonaDetail(
        {
          "Type": "Market_Connect",
          "subType": "Market Connect",
          "nResourceInstanceId": nResourceInstanceId,
          "fields": {
            "Market Opportunity Type": marketOppType,
            "Market Opportunity Name": marketOppName,
            "Revenue from Opportunity": revenueFromOpp,
            "Market channel cost": marketChannelCost,
            "Discount Amount (Paid by deAsra)": discountAmount,
            "Stall rent paid by Entrepreneur": stallRent,
            "Gross profit": grossProfit,
            "Additional cost for the opportunity disclosed by Entrepreneur(SGA)": addCostForOppDisclosed,
            Learnings,
            Challenges,
          }
        });

      setFormData({
        "nResourceInstanceId": "",
        "Market Opportunity Type": '',
        "Market Opportunity Name": '',
        "Revenue from Opportunity": '',
        "Market channel cost": '',
        "Discount Amount (Paid by deAsra)": '',
        "Stall rent paid by Entrepreneur": '',
        "Gross profit": '',
        "Additional cost for the opportunity disclosed by Entrepreneur(SGA)": '',
        "Learnings": '',
        "Challenges": '',
      })
      setIsEdit(false)
      setIsModalOpen(false)
    }
  }

  // // form to submit new data
  // const renderForm = () => (
  //   <Box>
  //     {/* <TextField
  //       name="nResourceInstanceId"
  //       label="Resource Instance Id"
  //       // value={selectedResourceInstanceId}
  //       value={formData["nResourceInstanceId"]}
  //       onChange={handleInputChange}
  //       fullWidth
  //       margin="normal"
  //     /> */}
  //     <TextField
  //       select
  //       name="nResourceInstanceId"
  //       label="Resource Instance Id"
  //       value={formData["nResourceInstanceId"]}
  //       onChange={handleInputChange}
  //       fullWidth
  //       margin="normal"
  //       SelectProps={{
  //         MenuProps: {
  //           PaperProps: {
  //             style: {
  //               maxHeight: 200, // height of dropdown
  //               width: 300,     // width of dropdown
  //             },
  //           },
  //         },
  //       }}
  //     >
  //       {uniqueMarketOppInstanceId.map((option) => (
  //         <MenuItem key={option} value={option}>{option}</MenuItem>
  //       ))}
  //     </TextField>

  //     <TextField
  //       select
  //       name="Market Opportunity Type"
  //       label="Market Opportunity Type"
  //       value={formData["Market Opportunity Type"]}
  //       onChange={handleInputChange}
  //       fullWidth
  //       margin="normal"
  //     >
  //       {['Corporate', 'Exhibition', 'E-Com', 'Bulk', 'Export'].map((option) => (
  //         <MenuItem key={option} value={option}>{option}</MenuItem>
  //       ))}
  //     </TextField>

  //     <TextField
  //       select
  //       name="Market Opportunity Name"
  //       label="Market Opportunity Name"
  //       value={formData["Market Opportunity Name"]}
  //       onChange={handleInputChange}
  //       fullWidth
  //       margin="normal"
  //     >
  //       {['Pune_PTK', 'Pune_PTH', 'Pune_Infrabeat', 'Pune_AMTP', 'Pune_ASTP', 'Pune_MAGILE', 'Pune_Emmersons', 'Pune_Icertis', 'Pune_Icertis', 'NG_PT', 'Pune_AP 81', 'Pune_Marrisoft', 'Pune_Summercourt', 'Pune_ATC'].map((option) => (
  //         <MenuItem key={option} value={option}>{option}</MenuItem>
  //       ))}
  //     </TextField>

  //     <TextField
  //       name="Revenue from Opportunity"
  //       label="Revenue from Opportunity"
  //       value={formData["Revenue from Opportunity"]}
  //       onChange={handleInputChange}
  //       fullWidth
  //       margin="normal"
  //       type='number'
  //     />

  //     <TextField
  //       name="Market channel cost"
  //       label="Market Channel Cost"
  //       value={formData["Market channel cost"]}
  //       onChange={handleInputChange}
  //       fullWidth
  //       margin="normal"
  //       type='number'
  //     />

  //     <TextField
  //       name="Discount Amount (Paid by deAsra)"
  //       label="Discount Amount (Paid by deAsra)"
  //       value={formData["Discount Amount (Paid by deAsra)"]}
  //       onChange={handleInputChange}
  //       fullWidth
  //       margin="normal"
  //       type='number'
  //     />

  //     <TextField
  //       name="Stall rent paid by Entrepreneur"
  //       label="Stall Rent Paid by Entrepreneur"
  //       value={formData["Stall rent paid by Entrepreneur"]}
  //       onChange={handleInputChange}
  //       fullWidth
  //       margin="normal"
  //       type='number'
  //     />

  //     <TextField
  //       name="Gross profit"
  //       label="Gross Profit"
  //       value={formData.grossProfit}
  //       onChange={handleInputChange}
  //       fullWidth
  //       margin="normal"
  //       type='number'
  //     />

  //     <TextField
  //       name="Additional cost for the opportunity disclosed by Entrepreneur(SGA)"
  //       label="Additional Cost for the Opportunity Disclosed by Entrepreneur (SGA)"
  //       value={formData["Additional cost for the opportunity disclosed by Entrepreneur(SGA)"]}
  //       onChange={handleInputChange}
  //       fullWidth
  //       margin="normal"
  //       type='number'
  //     />

  //     <TextField
  //       name="Learnings"
  //       label="Learnings"
  //       value={formData["Learnings"]}
  //       onChange={handleInputChange}
  //       fullWidth
  //       margin="normal"
  //     />

  //     <TextField
  //       name="Challenges"
  //       label="Challenges"
  //       value={formData["Challenges"]}
  //       onChange={handleInputChange}
  //       fullWidth
  //       margin="normal"
  //     />
  //   </Box>
  // );

  // render table to display data
  const renderTable = () => (
    <TableContainer component={Paper} style={{ maxHeight: "405px", overflowY: 'auto' }}>
      <Table stickyHeader style={{ tableLayout: 'fixed', width: '100%' }}>
        <TableHead>
          <TableRow>
            {/* {[
              "Resource Id",
              'Market Opportunity Type',
              'Market Opportunity Name',
              'Revenue from Opportunity',
              'Market channel cost',
              'Discount Amount (Paid by deAsra)',
              'Stall rent paid by Entrepreneur',
              'Gross profit',
              'Additional cost for the opportunity disclosed by Entrepreneur(SGA)',
              'Learnings',
              'Challenges',
            ].map((header) => (
              <TableCell key={header}>{header}</TableCell>
            ))} */}

            <TableCell>Resource Id</TableCell>
            <TableCell>Market Opportunity Type</TableCell>
            <TableCell>Market Opportunity Name</TableCell>
            <TableCell>Revenue from Opportunity</TableCell>
            <TableCell>Market channel cost</TableCell>
            <TableCell>
              Discount Amount <br /> (Paid by deAsra)
            </TableCell>
            <TableCell>Stall rent paid by Entrepreneur</TableCell>
            <TableCell>Gross profit</TableCell>
            <TableCell
              sx={{
                whiteSpace: 'normal',   // allow wrapping
                wordBreak: 'break-word', // break long words if needed
                lineHeight: 1.5,         // increase line spacing
                fontSize: '0.875rem',    // smaller font for clarity
                padding: '12px',         // adjust cell padding
              }}
            >Additional cost for the opportunity disclosed by Entrepreneur (SGA)</TableCell>
            <TableCell>Learnings</TableCell>
            <TableCell>Challenges</TableCell>
            {
              !isTestimonialScreen && <TableCell>Action</TableCell>
            }
          </TableRow>
        </TableHead>
        <TableBody>
          {/* {
            userMarketConnectPersonaDetails ? (
              userMarketConnectPersonaDetails.map((row, index) => (
                <TableRow key={index}>
                  <TableCell>{row["nResourceInstanceId"]}</TableCell>
                  <TableCell>{row["Market Opportunity Type"] ?? "N/A"}</TableCell>
                  <TableCell>{row["Market Opportunity Name"] ?? "N/A"}</TableCell>
                  <TableCell>{row["Revenue from Opportunity"] ?? "N/A"}</TableCell>
                  <TableCell>{row["Market channel cost"] ?? "N/A"}</TableCell>
                  <TableCell>{row["Discount Amount (Paid by deAsra)"] ?? "N/A"}</TableCell>
                  <TableCell>{row["Stall rent paid by Entrepreneur"] ?? "N/A"}</TableCell>
                  <TableCell>{row["Gross profit"] ?? "N/A"}</TableCell>
                  <TableCell>{row["Additional cost for the opportunity disclosed by Entrepreneur(SGA)"] ?? "N/A"}</TableCell>
                  <TableCell>{row["Learnings"] ?? "N/A"}</TableCell>
                  <TableCell>{row["Challenges"] ?? "N/A"}</TableCell>
                  <TableCell><Button onClick={() => handleAddEditButton(row)}>Edit</Button></TableCell>
                </TableRow>
              ))
            ) : <TableRow>
              <TableCell colSpan={12} align="center">
                No Data Found
              </TableCell>
            </TableRow>
          } */}

          {
            allResourcePersonaDetails ? (
              allResourcePersonaDetails.map((row, index) => (
                <TableRow key={index}>
                  <TableCell>{row["nResourceInstanceId"]}</TableCell>
                  <TableCell>{row["Market Opportunity Type"] ?? ""}</TableCell>
                  <TableCell>{row["Market Opportunity Name"] ?? ""}</TableCell>
                  <TableCell>{row["Revenue from Opportunity"] ?? ""}</TableCell>
                  <TableCell>{row["Market channel cost"] ?? ""}</TableCell>
                  <TableCell>{row["Discount Amount (Paid by deAsra)"] ?? ""}</TableCell>
                  <TableCell>{row["Stall rent paid by Entrepreneur"] ?? ""}</TableCell>
                  <TableCell>{row["Gross profit"] ?? ""}</TableCell>
                  <TableCell>{row["Additional cost for the opportunity disclosed by Entrepreneur(SGA)"] ?? ""}</TableCell>
                  <TableCell>{row["Learnings"] ?? ""}</TableCell>
                  <TableCell>{row["Challenges"] ?? ""}</TableCell>
                  {
                    !isTestimonialScreen && (
                      <TableCell>
                        {
                          row["isAlreadyPersonaExisting"] ? (
                            <Button onClick={() => handleAddEditButton(row, "edit")}>{"Edit"}</Button>
                          ) : (
                            <Button onClick={() => handleAddEditButton(row, "add")}>{"Add"}</Button>
                          )
                        }
                      </TableCell>
                    )
                  }
                </TableRow>
              ))
            ) : <TableRow>
              <TableCell colSpan={12} align="center">
                No Data Found
              </TableCell>
            </TableRow>
          }
        </TableBody>
      </Table>
    </TableContainer>
  );

  // handleFormSubmit
  const submitMarketConnectPersonaForm = () => {
    console.log(">>>Submit clicked ");
    const {
      nResourceInstanceId,
      "Market Opportunity Type": marketOppType,
      "Market Opportunity Name": marketOppName,
      "Revenue from Opportunity": revenueFromOpp,
      "Market channel cost": marketChannelCost,
      "Discount Amount (Paid by deAsra)": discountAmount,
      "Stall rent paid by Entrepreneur": stallRent,
      "Gross profit": grossProfit,
      "Additional cost for the opportunity disclosed by Entrepreneur(SGA)": addCostForOppDisclosed,
      Learnings,
      Challenges,
      ...remFormData
    } = formData

    let data = {
      "Type": "Market_Connect",
      "subType": "Market Connect",
      "nResourceInstanceId": nResourceInstanceId,
      "fields": {
        "Market Opportunity Type": marketOppType,
        "Market Opportunity Name": marketOppName,
        "Revenue from Opportunity": revenueFromOpp,
        "Market channel cost": marketChannelCost,
        "Discount Amount (Paid by deAsra)": discountAmount,
        "Stall rent paid by Entrepreneur": stallRent,
        "Gross profit": grossProfit,
        "Additional cost for the opportunity disclosed by Entrepreneur(SGA)": addCostForOppDisclosed,
        Learnings,
        Challenges,
      }
    }

    handleSubmitPersonaDetails(data);

    if (!isPersonaLoading) {
      // handleFormToggle(isPersonaFormOpen);
      setFormData({
        "nResourceInstanceId": "",
        "Market Opportunity Type": '',
        "Market Opportunity Name": '',
        "Revenue from Opportunity": '',
        "Market channel cost": '',
        "Discount Amount (Paid by deAsra)": '',
        "Stall rent paid by Entrepreneur": '',
        "Gross profit": '',
        "Additional cost for the opportunity disclosed by Entrepreneur(SGA)": '',
        "Learnings": '',
        "Challenges": '',
      })

      handleFormToggle();
      setIsModalOpen(false);
    }
  }

  const handleCancelForm = () => {
    setIsFormOpen(false);
    setIsEdit(false);
    setFormData({
      "nResourceInstanceId": "",
      "Market Opportunity Type": '',
      "Market Opportunity Name": '',
      "Revenue from Opportunity": '',
      "Market channel cost": '',
      "Discount Amount (Paid by deAsra)": '',
      "Stall rent paid by Entrepreneur": '',
      "Gross profit": '',
      "Additional cost for the opportunity disclosed by Entrepreneur(SGA)": '',
      "Learnings": '',
      "Challenges": '',
    })
    setIsModalOpen(false);
  }

  console.log(userMarketConnectPersonaDetails, ">>>>>userMarketConnectPersonaDetails in market form");
  console.log(formData, ">>>>>formData");
  console.log(isModalOpen, ">>>>isModalOpen");
  console.log(marketConnectResourcesOfUser, ">>>>>marketConnectResourcesOfUser");
  console.log(marketConnectResourcesOfUser, ">>>>>marketConnectResourcesOfUser");
  console.log(allResourcePersonaDetails, ">>>>allResourcePersonaDetails");

  return (
    <Box style={{ padding: '16px' }} className={`${isPersonaLoading && "set-opacity"}`}>
      {isPersonaLoading && <Spinner className="center" />}
      <Typography variant="h6" style={{ fontWeight: 'bold', color: '#6D1B7B' }}>
        {title}
      </Typography>

      {/* {isFormOpen ? renderForm() : renderTable()} */}
      {/* {isPersonaFormOpen ? renderForm() : renderTable()} */}
      {renderTable()}

      {/* <Button
        variant="contained"
        color="primary"
        onClick={handleFormToggle}
        style={{ marginTop: 20, width: '100%' }}
      >
        {isFormOpen ? 'Cancel' : 'Add New Opportunity'}
      </Button> */}
      {/* <Box>
        {
          isFormOpen ?
            // isPersonaFormOpen ?
            <Box display="flex" justifyContent="flex-end" padding="0px 20px" style={{ gap: "20px" }}>
              <Button
                variant="contained"
                color="primary"
                // onClick={handleFormCancel}
                // onClick={() => setIsFormOpen(false)}
                onClick={() => handleCancelForm()}
                style={{ marginTop: 20, backgroundColor: "#75287C", color: "#fff", textTransform: "none" }}
              >
                Cancel
              </Button>

              {
                !isEdit ? <Button
                  variant="contained"
                  color="primary"
                  // onClick={handleFormToggle}
                  onClick={submitMarketConnectPersonaForm}
                  style={{ marginTop: 20, backgroundColor: "#75287C", color: "#fff", textTransform: "none" }}
                >
                  Submit
                </Button> : <Button
                  variant="contained"
                  color="primary"
                  // onClick={handleFormToggle}
                  onClick={() => handleUpdateButtonClick(formData)}
                  style={{ marginTop: 20, backgroundColor: "#75287C", color: "#fff", textTransform: "none" }}
                >
                  Update
                </Button>
              }

            </Box>
            :
            <Box display="flex" justifyContent="flex-end" padding="0px" style={{ gap: "20px" }}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleFormToggle}
                style={{ marginTop: 20, width: '300px', backgroundColor: "#75287C", color: "#fff", textTransform: "none" }}
              >
                Add New Persona Detail
              </Button>
            </Box>
          // ""
        }

      </Box> */}

      {/* <Box display="flex" justifyContent="flex-end" padding="0px" style={{ gap: "20px" }}>
        <Button
          variant="contained"
          color="primary"
          // onClick={handleFormToggle}
          onClick={() => setIsModalOpen(true)}
          style={{ marginTop: 20, width: '300px', backgroundColor: "#75287C", color: "#fff", textTransform: "none" }}
          disabled={marketConnectResourcesOfUser.length <= 0 || leftResourcesForAddingPersona.length <= 0}
        >
          Add New Persona Detail
        </Button>
      </Box> */}

      <FormModalMarketConnect
        open={isModalOpen}
        // onClose={() => setIsModalOpen(false)}
        onClose={() => handleCancelForm()}
        isPersonaLoading={isPersonaLoading}
        formData={formData}
        handleInputChange={handleInputChange}
        uniqueMarketOppInstanceId={uniqueMarketOppInstanceId}
        isEdit={isEdit}
        handleUpdateButtonClick={handleUpdateButtonClick}
        submitMarketConnectPersonaForm={submitMarketConnectPersonaForm}
        marketConnectAlreadyFilledPersonaInstanceId={marketConnectAlreadyFilledPersonaInstanceId}
        marketConnectResourcesOfUser={marketConnectResourcesOfUser}
      />
    </Box>
  );
}
